import React, { Component, Fragment } from 'react';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import { get, postWithHeadersResponse } from '../../../server/actions'
import { BeatLoader } from 'react-spinners';
import PropTypes from "prop-types";
import $ from 'jquery';
import OrderCalender, { newCategories } from './orderCalender.jsx';
import ReviewMenu from './reviewMenu';
import { URL_VERSION, MealTypes, MenuOrderTypes, currency_symbol, URL_VERSION3 } from '../../../server/constants';
import InstantPayment from './instantPayment';
import {
    convertTwoDecimalPoint, _addNotification, _addNotificationError, getModuleEnum,
    getAccessLevelByModule, isRegularLunchOrderType, getSchoolGrades, groupBy,
    getNotWorkingDays, getParent_schoolFoodServiceInfo, convertToTimezone, getOrderCustomMessage, getDonationData
} from '../../../server/util'
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getOrderMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import Background from '../../../assets/img/pancake.png';
import PaySummary from './paySummary';
let studentRecId = 0;
let allergiesData = '';
const viewStatus = {
    LOAD: 'LOADING',
    ORDER: 'ORDER',
    REVIEW: 'REVIEW',
    INSTPAY: 'INSTPAY',
    PAYSUMMARY: 'SUMMARY'
}
const mealItemType = {
    SIDE: 'SIDE',
    MEAL: 'MEAL',
    EXTRA: 'EXTRA'
}

let dot = {
    backgroundColor: '#b2e87a',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let dot2 = {
    backgroundColor: 'orange',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let fixedPossition = {
    //display:'flex',
    position: "fixed",
    left: 0,
    bottom: "10vh",
    width: "100%",
    backgroundColor: "white",
    textAlign: "center",
}
let isMobile = false;
let scrollY = 0;
let scrollX = 0;
const modEnum = getModuleEnum();
let gradeList = [];
const styles = {
    bgImage: {
        backgroundImage: `url(${Background})`,
        height: '90vh',
        filter: 'blur(19px)',
        webkitFilter: 'blur(19px)',
        backgroundPosition: 'center',
        backgroundRepeat: ' no-repeat',
        backgroundSize: 'cover'
    },
    bgText: {
        backgroundColor: 'rgb(0,0,0)',
        backgroundColor: 'rgba(0,0,0, 0.4)',
        color: 'white',
        border: '1px solid rgb(247 246 246 / 17%)',
        boxShadow: 'rgb(136 136 136) 0px 0px 9px 0px',
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '2',
        width: '70%',
        padding: '20px',
        textAlign: 'center'
    }
}
class OrderMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processedTypes: {},
            width: window.innerWidth,
            loading: false,
            selectedStudentId: 0,
            isParent: false,
            studentData: {},
            isInstantPayment: false,
            isPrePayForOrderStatus: false,
            isAddBalOnline: false,
            view: viewStatus.LOAD,
            mainOrderObject: {},
            donateSchools: this.props.schoolObject,
            menuObj: {},
            isPaymentPending: false,
            itemsList: [],
            schoolMeals: {},
            initialPrices: {},
            mealType: '',
            noMenuMessage: false,
            mealTypes: (getOrderMenuOptions()[0] || ''),
            schoolStudents: {},
            scrollTop: 0
        }
    }
    componentWillMount = () => {
        window.addEventListener('resize', this.handleWindowSizeChange);
        const id = this.context.router.route.match.params.id;
        if (sessionStorage.getItem('ROLE') == 'ROLE_PARENT') {
            const _schoolStudents = (this.context.router.route.location.state || {}).list || {};
            this.setState({ isParent: true, schoolStudents: _schoolStudents });
        } else if (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') {
            const _mealType = this.context.router.route.match.params.mealType;
            this.setState({ mealType: _mealType });

        }
        studentRecId = id;
        this.getStudentDetails(id)

    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;

        const scrollDiv = document.getElementById('scrollDiv');

        if (scrollDiv) {
            scrollDiv.addEventListener('scroll', () => {
                this.setState({ scrollTop: scrollDiv.scrollTop });
            });
        }

    }
    componentWillUnmount = () => {
        const scrollDiv = document.getElementById('scrollDiv');
        if (scrollDiv) {
            scrollDiv.removeEventListener('scroll', () => { });
        }
    }
    componentWillUpdate = () => {
        //alert("Will update")

        scrollX = $(document).find('#mCal').parent().scrollLeft() || 0;

        scrollY = $(document).scrollTop();
    }
    getInstantPaymentStatus = (id) => {
        if (sessionStorage.getItem('ROLE') == 'ROLE_PARENT') {
            const sId = id;
            return getAccessLevelByModule(modEnum.IPFO, sId);
        } else {
            return getAccessLevelByModule(modEnum.IPFO);
        }
    }
    getAddBalOnlineStatus = (id) => {
        if (sessionStorage.getItem('ROLE') == 'ROLE_PARENT') {
            const sId = id;
            return getAccessLevelByModule(modEnum.APO, sId);
        } else {
            return getAccessLevelByModule(modEnum.APO);
        }
    }
    getPrePayForOrderStatus = (id) => {
        if (sessionStorage.getItem('ROLE') == 'ROLE_PARENT') {
            const sId = id;
            return getAccessLevelByModule(modEnum.PPFO, sId);
        } else {
            return getAccessLevelByModule(modEnum.PPFO);
        }
    }
    getStudentDetails = (id) => {
        get('/studentUsers/' + id + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            allergiesData = data.allergies;
            let studentData = data || {};
            //studentIsFreeMeal=data.isFreeMealEligible==undefined?false:data.isFreeMealEligible;
            //studentIsReducePrice=data.isReducePriceEligible==undefined?false:data.isReducePriceEligible;
            this.setState({ lunchBal: data.accBalance || 0.00 });
            get('/studentUsers/' + studentData._links.self.href.split('/').pop() + '/mealSchool?access_token=').then((response) => {
                if (!response.ok) {
                    this._addNotificationError();
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                // alert("came here")
                studentData.schoolName = data.schoolName;
                studentData.mealSchoolId = data._links.self.href.split("/").pop();
                studentData.studentRecId = id;
                const _mealTypeArray = (getOrderMenuOptions(this.state.isParent ? studentData.mealSchoolId : 0) || []);
                const _mainOrderObject = {};
                const _processedTypes = {};
                _mealTypeArray.map(itm => {
                    _mainOrderObject[itm] = {};
                    _processedTypes[itm] = false;
                })
                const selectedMealType = this.state.isParent ? (_mealTypeArray[0] || '') : this.state.mealType
                this.setState({
                    studentData: studentData,
                    loading: false,
                    isInstantPayment: this.getInstantPaymentStatus(studentData.mealSchoolId),
                    isPrePayForOrderStatus: this.getPrePayForOrderStatus(studentData.mealSchoolId),
                    isAddBalOnline: this.getAddBalOnlineStatus(studentData.mealSchoolId),
                    mealType: selectedMealType,
                    mainOrderObject: _mainOrderObject,
                    processedTypes: _processedTypes
                }, () => {
                    this.getMenu(selectedMealType)
                }
                )
            }).catch(
                (error) => {
                    console.log('Parent dashboard error', error);
                }
            );

        }).catch(
            (error) => {
                console.log('Parent dashboard error', error);
            }
        );
    }
    calculateDiscount = (obj) => {
        const hideDays = getNotWorkingDays(this.state.isParent ? this.state.studentData.mealSchoolId : 0)
        let _applyDiscount = false;
        let _itemPriceDisForMonthlyOrder = 0;
        const currentMonthGroup = groupBy(((obj).menuItemsList || []), 'date')
        const currentMonthDates = Object.keys(currentMonthGroup).filter(dt => {
            return dt !== 'null'
        });
        _applyDiscount = currentMonthDates.every(dt => {
            const day = moment(dt, 'YYYY-MM-DD').day();
            const list = currentMonthGroup[dt].filter(itm => {
                return (newCategories.includes(itm.type) || itm.type === mealItemType.MEAL || itm.type === MealTypes.BREAKFAST.toUpperCase() || itm.type === MealTypes.SNACK.toUpperCase() || itm.type === MealTypes.DINNER.toUpperCase())
            })
            return list.length == 0 || list.some(itm => {
                return itm.isSelected
            }) || hideDays.includes(day);
        })
        _itemPriceDisForMonthlyOrder = obj.itemPriceDisForMonthlyOrder || 0;
        return {
            applyDiscount: _applyDiscount,
            itemPriceDisForMonthlyOrder: _itemPriceDisForMonthlyOrder
        }
    }
    formatServiceData = (_menuObj, initformat = false) => {
        const studentData = this.state.studentData;
        let studentIsFreeMeal = ((studentData.isFreeMealEligible || false) ? true : ((this.state.mealType === MealTypes.BREAKFAST) && studentData.beforeCare) ? true : false);
        let studentIsReducePrice = studentData.isReducePriceEligible || false;
        let isExtraPreOrder = studentData.isExtraPreOrder || false;
        let allergyAlertTrue = false;
        let initPrice = 0.00;
        if (initformat) {
            (_menuObj.menuItemsList || []).map((item, i) => {
                const idx = _menuObj['orderedMenu'].find(menuItem => {
                    return menuItem.mealCalendarId == item.mealCalendarId
                });
                if (idx) {
                    if (item.type === mealItemType.EXTRA) {
                        item['isSelected'] = true;
                        item.quantity = idx.qty
                    }
                    else if (item.type === mealItemType.SIDE) {
                        if (_menuObj.isSideSelect) {
                            item.quantity = idx.qty
                            item['isSelected'] = true;
                        } else {
                            item['isSelected'] = false;
                        }
                    }
                    else {
                        item['isSelected'] = true;
                        item.quantity = idx.qty
                    }
                } else {
                    item['isSelected'] = false;
                }
                try {
                    if ((item.allergensInfo || '') !== '' && (allergiesData == '' ? null : allergiesData) !== null) {
                        item.allergyAlert = this.findAllergies(allergiesData.toLowerCase(), (item.allergensInfo || '').toLowerCase())
                        if (item.allergyAlert) {
                            allergyAlertTrue = true;
                        }
                    }
                } catch (e) {
                    console.log("Error in finding allergies", e)
                }
                if (newCategories.includes(item.type) || item.type == mealItemType.MEAL || item.type === MenuOrderTypes.ITEMIZE.toUpperCase() || item.type === MealTypes.SNACK.toUpperCase() || item.type === MealTypes.BREAKFAST.toUpperCase() || item.type === MealTypes.DINNER.toUpperCase()) {
                    item.start = moment(item.start, 'YYYY-MM-DD');
                    item.end = moment(item.end, 'YYYY-MM-DD');
                } else {
                    if (item.type == mealItemType.EXTRA) {
                        item.start = moment(item.start, 'YYYY-MM-DD').set({ hours: 2, minutes: 0, seconds: 0 });
                        item.end = moment(item.end, 'YYYY-MM-DD').set({ hours: 2, minutes: 0, seconds: 0 });
                    } else {
                        item.start = moment(item.start, 'YYYY-MM-DD').set({ hours: 1, minutes: 0, seconds: 0 });
                        item.end = moment(item.end, 'YYYY-MM-DD').set({ hours: 1, minutes: 0, seconds: 0 });
                    }
                }
                item.start = moment(item.start, 'YYYY-MM-DD');
                item.end = moment(item.end, 'YYYY-MM-DD');
                item.eventId = i;
                item.isSideSelect = _menuObj.isSideSelect;
                item.title = item.name
            });
            _menuObj['allergyAlertTrue'] = allergyAlertTrue;
            _menuObj['isSideSelect'] = _menuObj.isSideSelect;
        }

        const { applyDiscount, itemPriceDisForMonthlyOrder } = this.calculateDiscount(_menuObj);
        let _initPrices = 0;
        (_menuObj.menuItemsList || []).map(item => {
            if (item.type === mealItemType.EXTRA && item.isSelected) {
                const qyt = item.quantity || 1
                _initPrices += parseFloat(convertTwoDecimalPoint((item.price * qyt), 2));
            }
            else if (item.type === mealItemType.SIDE && item.isSelected) {
                _initPrices += parseFloat(convertTwoDecimalPoint((studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : item.price), 2))
            } else {
                if (item.isSelected) {
                    const qyt = item.quantity || 1
                    if (studentIsFreeMeal) {
                        _initPrices += 0;
                    } else if (studentIsReducePrice) {
                        _initPrices += parseFloat(convertTwoDecimalPoint((item.reducedPrice * qyt), 2));
                    } else {
                        item['applyDiscount'] = applyDiscount;
                        item['itemPriceDisForMonthlyOrder'] = itemPriceDisForMonthlyOrder;

                        item['afterDiscountAmount'] = parseFloat(convertTwoDecimalPoint((item.price * qyt), 2)) - parseFloat(convertTwoDecimalPoint(itemPriceDisForMonthlyOrder, 2));
                        _initPrices += applyDiscount ? item.afterDiscountAmount : parseFloat(convertTwoDecimalPoint((item.price * qyt), 2));
                    }
                }
            }
        });
        return {
            menuObj: _menuObj,
            initPrice: _initPrices,
            allergyAlertTrue: allergyAlertTrue
        }
    }
    formatSelectedItems = () => {
        const _menuObj = this.state.menuObj;
        let finalObj = {};
        Object.keys(_menuObj).map(yearMonth => {
            const { applyDiscount, itemPriceDisForMonthlyOrder } = this.calculateDiscount(_menuObj[yearMonth]);
            finalObj[yearMonth] = {
                menuItemsList: _menuObj[yearMonth].menuItemsList.filter(item => {
                    if (newCategories.includes(item.type) || item.type === mealItemType.MEAL || item.type === mealItemType.BREAKFAST || item.type === mealItemType.SNACK || item.type === mealItemType.DINNER) {
                        item['applyDiscount'] = applyDiscount;
                        item['itemPriceDisForMonthlyOrder'] = itemPriceDisForMonthlyOrder;
                        item['afterDiscountAmount'] = parseFloat(convertTwoDecimalPoint(item.price, 2)) - parseFloat(convertTwoDecimalPoint(itemPriceDisForMonthlyOrder, 2));
                    }
                    return (item.isSelected == true || ((item.type !== mealItemType.MEAL) && newCategories.includes(item.type)));
                })
            }
        })
        return finalObj;
    }
    findAllergies(allergies, itemDesc) {
        let res = allergies.replace(/[, ]+/g, " ").trim();
        let parts = res.split(' ')
        let x = parts.map(allergy => {
            return this.findAllergy(allergy, itemDesc)
        })
        if (x.indexOf(true) >= 0) {
            return true
        } else return false
    }
    aContainsB(a, b) {
        return a.split(',').includes(b);
    }
    findAllergy(allergy, itemDesc) {
        if (this.aContainsB(itemDesc, allergy)) {
            return true
        } else {
            return false
        }
    }
    calculatePrice = () => {
        const _menuObj = this.state.menuObj;
        const studentData = this.state.studentData;
        let studentIsFreeMeal = ((studentData.isFreeMealEligible || false) ? true : ((this.state.mealType === MealTypes.BREAKFAST) && studentData.beforeCare) ? true : false);
        let studentIsReducePrice = studentData.isReducePriceEligible || false;
        let isExtraPreOrder = studentData.isExtraPreOrder || false;
        let priceObj = {};
        Object.keys(_menuObj).map(yearMonth => {
            const { menuObj, initPrice } = this.formatServiceData(_menuObj[yearMonth], false);
            priceObj[yearMonth] = initPrice;
        })
        return priceObj;
    }
    getMenu = (mType) => {
        this.setState({
            loading: true
        })
        const studentIsFreeMeal = ((this.state.studentData.isFreeMealEligible || false) ? true : ((this.state.mealType === MealTypes.BREAKFAST) && this.state.studentData.beforeCare) ? true : false);
        const studentIsReducePrice = this.state.studentData.isReducePriceEligible || false;
        //const _type=(mType===MealTypes.LUNCH) &&!isRegularLunchOrderType(this.state.isParent?this.state.studentData.mealSchoolId:0)?MenuOrderTypes.ITEMIZE:this.state.mealType;
        get('/mealSummaryDetails?menuSummaryId=0&mealSchoolId=' + this.state.studentData.mealSchoolId + '&grade=' + this.state.studentData.gradeName + '&studentRecId=' + studentRecId + '&itemType=' + this.state.mealType + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ itemsList: data.availableMenu })
            console.log('Got School Meals', data);
            let _menuObj = {};
            let _initialPrices = {};
            Object.keys((data || {}).availableMenu || {}).map(yearMonth => {
                _menuObj[yearMonth] = (((data || {}).availableMenu || {})[yearMonth] || {});
                _menuObj[yearMonth]['orderedMenu'] = (((data || {}).orderedMenu || {})[yearMonth] || {}).menuItemsList || [];
                _menuObj[yearMonth]['isSideSelect'] = (((data || {}).availableMenu || {})[yearMonth] || {}).isSideSelect;
                const { menuObj, initPrice, allergyAlertTrue } = this.formatServiceData(_menuObj[yearMonth], true);
                _menuObj[yearMonth] = menuObj;
                _initialPrices[yearMonth] = initPrice;
                _menuObj[yearMonth]['allergyAlertTrue'] = allergyAlertTrue;
            });
            let _noMenuMessage = false;
            _noMenuMessage = Object.keys(_menuObj).some(yearMonth => {
                return (_menuObj[yearMonth].menuItemsList || []).length > 0
            })

            this.setState({
                menuObj: _menuObj,
                //isPaymentPending:data.isPaymentPending,
                loading: false,
                view: viewStatus.ORDER,
                initialPrices: _initialPrices,
                noMenuMessage: _noMenuMessage
            })
        })
            .catch(
                (error) => {
                    this.setState({
                        menuObj: {},
                        loading: false,
                        view: viewStatus.ORDER,
                        initialPrices: {}
                    })
                });
    }
    prepareSaveObject = (salesTaxAmt) => {
        let body = {};
        const _menuObj = this.state.menuObj;
        body.studentId = this.state.studentData.studentRecId;
        body['calendarIdsByMonth'] = {};
        body['calIdWCountByMonth'] = {};
        let _calendarIdsByMonth = {};
        let _calIdWCountByMonth = {};
        Object.keys(_menuObj).map(yearMonth => {
            _calendarIdsByMonth[yearMonth] = [];
            _calIdWCountByMonth[yearMonth] = {};
            let _tempList = []
            _menuObj[yearMonth].menuItemsList.sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                if (newCategories.includes(item.type) || item.type === mealItemType.MEAL || item.type === MenuOrderTypes.ITEMIZE || item.type === MealTypes.SNACK.toUpperCase() || item.type === MealTypes.BREAKFAST.toUpperCase() || item.type === MealTypes.DINNER.toUpperCase()) {
                    if (item.isSelected == true) {
                        _calendarIdsByMonth[yearMonth].push(item.mealCalendarId);
                        _calIdWCountByMonth[yearMonth][item.mealCalendarId] = item.quantity || 1
                        _tempList.push(item)
                    }
                }
                else if (item.type === mealItemType.SIDE) {
                    if (_menuObj[yearMonth].isSideSelect) {
                        if (item.isSelected) {
                            _calendarIdsByMonth[yearMonth].push(item.mealCalendarId);
                            _calIdWCountByMonth[yearMonth][item.mealCalendarId] = item.quantity || 1
                            _tempList.push(item)
                        }
                    } else {
                        /* let mealSelected=_tempList.some(itm=>{
                            return itm.start.format('YYYY-MM-DD')==item.start.format('YYYY-MM-DD') && itm.isSelected==true && itm.type!==mealItemType.SIDE
                        })
                        if(mealSelected){
                            _calendarIdsByMonth[yearMonth].push(item.mealCalendarId);
                            _tempList.push(item);
                        }  */
                    }
                }

                if (item.type === mealItemType.EXTRA) {
                    if (item.isSelected == true) {
                        _calendarIdsByMonth[yearMonth].push(item.mealCalendarId);
                        _calIdWCountByMonth[yearMonth][item.mealCalendarId] = item.quantity || 1
                        _tempList.push(item)
                    }
                }
                else {
                    // _calendarIdsByMonth[yearMonth].push(item.mealCalendarId);
                }
            });
        });
        Object.keys(_calendarIdsByMonth).map(yearMonth => {
            //if(_calendarIdsByMonth[yearMonth].length>0){
            body.calendarIdsByMonth[yearMonth] = _calendarIdsByMonth[yearMonth] || [];
            body.calIdWCountByMonth[yearMonth] = _calIdWCountByMonth[yearMonth] || [];
            //}
        })
        body['salesTaxAmt'] = salesTaxAmt;
        return body;

    }
    prepareForSave = (isInstantPayment = false, salesTaxAmt, callback) => {
        let body = this.prepareSaveObject(salesTaxAmt);
        if (isInstantPayment) {
            return body
        } else {
            this.mealOrder(body, callback);
        }
    }
    stripePaymentDone = (callback) => {
        let _processedTypes = this.state.processedTypes;
        _processedTypes[this.state.mealType] = true;
        let idx = Object.keys(_processedTypes).findIndex(type => {
            return type == this.state.mealType;
        })
        _addNotification('Order Payment processed successfully', this);
        if (idx > -1 && (Object.keys(_processedTypes).length - 1) > (idx)) {
            const _type = Object.keys(_processedTypes)[idx + 1]
            this.setState({
                loading: false,
                mealType: _type,
                processedTypes: _processedTypes,
                view: viewStatus.ORDER
            }, () => {
                this.getMenu(_type)
            })
        } else {
            this.setState({
                loading: false,
                processedTypes: _processedTypes
            });
            setTimeout(() =>
            (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN' ?
                this.context.router.history.push('/schoolAdmin/viewOrdersGrid')
                : window.location.replace('/parent')), 2000);
        }
        if (callback)
            callback(true);
    }
    mealOrder = (formData, callback) => {
        this.setState({ loading: true });
        let headers = {
            'Content-Type': 'application/json'
        }
        formData['systemDt'] = moment().format('YYYY-MM-DDTHH:mm:ss');
        let loginUserName = (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN' ? sessionStorage.getItem('loggedUserName') : sessionStorage.getItem('loggedInUserInfo'));
        //const _type=(this.state.mealType===MealTypes.LUNCH) &&!isRegularLunchOrderType(this.state.isParent?this.state.studentData.mealSchoolId:0)?MenuOrderTypes.ITEMIZE:this.state.mealType;
        postWithHeadersResponse(URL_VERSION3 + '/orderMenu/' + this.state.mealType + '?access_token=', JSON.stringify(formData),
            headers).then((response) => {
                if (response.statusCode !== 200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 200) {
                    let _processedTypes = this.state.processedTypes;
                    _processedTypes[this.state.mealType] = true;
                    let idx = Object.keys(_processedTypes).findIndex(type => {
                        return type == this.state.mealType;
                    })
                    _addNotification(res.statusMessage, this);
                    if (idx > -1 && (Object.keys(_processedTypes).length - 1) > (idx)) {
                        const _type = Object.keys(_processedTypes)[idx + 1]
                        this.setState({
                            loading: false,
                            mealType: _type,
                            processedTypes: _processedTypes,
                            view: viewStatus.ORDER
                        }, () => {
                            this.getMenu(_type)
                        })
                    } else {
                        this.setState({
                            loading: false,
                            processedTypes: _processedTypes
                        });
                        setTimeout(() =>
                        (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN' ?
                            this.context.router.history.push('/schoolAdmin/viewOrdersGrid')
                            : window.location.replace('/parent')), 2000);
                    }
                    if (callback)
                        callback(true);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    _addNotificationError(error.message, this)
                    console.log('Meal order Creation Error', error)
                    if (callback)
                        callback(true);
                }
            );
    }
    onPaymentDone = (resp, callback) => {
        let payResp = resp;
        let menuResp = this.prepareForSave(true, resp.salesTaxAmt);
        this.mealOrder({ ...menuResp, ...payResp }, callback);
    }
    saveMenuForUnionPay = (resp) => {
        let payResp = resp;
        let menuResp = this.prepareForSave(true, resp.salesTaxAmt);
        return { ...menuResp, ...payResp };
    }
    paymentProcessPendingBox = () => {
        const { isPaymentPending } = this.state;
        return (
            isPaymentPending ?
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h3 className='text-danger' style={{ paddingTop: '5px', textTransform: 'none' }}>Previous payment process not at completed. It is in progress...</h3>
                        <span className='text-danger' style={{ paddingTop: '3px', textTransform: 'none', fontSize: '17px' }}>Please wait for complete the process or contact school admin</span>
                    </div>
                </div>
                : null
        )
    }

    render() {

        const { width } = this.state;
        isMobile = width <= 500;
        gradeList = getSchoolGrades(this.state.isParent ? this.state.studentData.mealSchoolId : 0, false);
        const gradeGroup = groupBy(gradeList || [], 'value');
        const foodServiceInfo = getParent_schoolFoodServiceInfo(this.state.isParent ? this.state.studentData.mealSchoolId : 0);
        return (
            <Fragment>
                <section className="full-width clearfix">
                    <NotificationSystem ref="notificationSystem" />
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div id="containerTop" className="container ">
                        {
                            isMobile ? <Fragment>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12">
                                        <div className="sectionTitle">
                                            <h2><span>{`Ordering Meals for ${this.state.studentData.firstName} ${this.state.studentData.lastName} ${getAccessLevelByModule(modEnum.NSO, this.state.isParent ? this.state.studentData.mealSchoolId : 0) ? '' : ', Grade ' + ((gradeGroup[this.state.studentData.gradeName] || [])[0] || {}).label || ''}`}</span></h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ display: "flex", alignItems: "flex-end" }}>
                                    <div className="col-xs-3 col-sm-3">
                                        <button className=" btn bg-color-4" style={{ margin: '0px', color: '#ffffff' }} onClick={(e) => {
                                            e.preventDefault();
                                            let _self = this;
                                            _self.context.router.history.goBack();
                                        }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>

                                    </div>
                                    <div className="col-xs-9 col-sm-9 text-right">
                                        <MenuOptions menuOptionsList={getOrderMenuOptions(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                            onOptionSelect={(type) => {
                                                this.setState({ mealType: type }, () => {
                                                    this.getMenu(type)
                                                })
                                            }} selectedOption={(this.state.mealType)} />
                                    </div>
                                </div>
                            </Fragment> :
                                <div className="sectionTitle row">
                                    <h2>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <span style={{ marginTop: '6px' }}>{`Ordering Meals for ${this.state.studentData.firstName} ${this.state.studentData.lastName} ${getAccessLevelByModule(modEnum.NSO, this.state.isParent ? this.state.studentData.mealSchoolId : 0) ? '' : ', Grade ' + ((gradeGroup[this.state.studentData.gradeName] || [])[0] || {}).label || ''}`}</span>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <MenuOptions menuOptionsList={getOrderMenuOptions(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                    onOptionSelect={(type) => {
                                                        this.setState({ mealType: type }, () => {
                                                            this.getMenu(type)
                                                        })
                                                    }} selectedOption={(this.state.mealType)} />
                                                <button className=" btn bg-color-4" style={{ margin: '5px', color: '#ffffff', fontSize: '12px' }} onClick={(e) => {
                                                    e.preventDefault();
                                                    let _self = this;
                                                    _self.context.router.history.goBack();
                                                }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                                            </div>

                                        </div>
                                    </h2>

                                </div>
                        }

                        <div className="row">
                            <div className="col-md-12">
                                {
                                    this.state.view === viewStatus.ORDER ?
                                        (!this.state.noMenuMessage ?
                                            <div className="row">
                                                <div className="col-md-12 text-center">
                                                    <div style={styles.bgImage}></div>
                                                    <div style={styles.bgText}>
                                                        Menu not available</div>
                                                </div>
                                            </div> :
                                            (this.state.studentData.freezePreOrder === true && this.state.isParent) ?
                                                <div className='row'>
                                                    <div className='col-md-12 text-center'>
                                                        <div style={styles.bgImage}></div>
                                                        <div style={styles.bgText}>
                                                            Pre-ordering Restricted by Admin. Please contact Food Service Manager {foodServiceInfo && <Fragment>at - <br /><br /><span style={{ textTransform: 'uppercase' }}>{(foodServiceInfo || {}).contactPName}</span><br />Ph: <strong>{(foodServiceInfo || {}).contactPPhone}</strong> <br />Email: <strong>{(foodServiceInfo || {}).contactPEmail}</strong></Fragment>}
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <OrderCalender isMobile={isMobile}
                                                    isInstantPayment={this.state.isInstantPayment}
                                                    isPrePayForOrderStatus={this.state.isPrePayForOrderStatus}
                                                    isParent={this.state.isParent}
                                                    isPaymentPending={this.state.isPaymentPending}
                                                    paymentProcessPendingBox={this.paymentProcessPendingBox}
                                                    gradeList={gradeList}
                                                    currency_symbol={currency_symbol(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                    mealType={this.state.mealType}
                                                    isMultiSelect={(!isRegularLunchOrderType(this.state.isParent ? this.state.studentData.mealSchoolId : 0)) ? true : false}
                                                    isWeeklyOrder={(!isRegularLunchOrderType(this.state.isParent ? this.state.studentData.mealSchoolId : 0)) ? true : false}
                                                    hiddenDays={getNotWorkingDays(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                    dataSet={{ ...this.state.menuObj }}
                                                    price={this.calculatePrice()}
                                                    initialPrices={this.state.initialPrices || {}}
                                                    studentData={this.state.studentData}
                                                    onMenuSelectionChange={(_menuObj) => {
                                                        this.setState({ menuObj: { ..._menuObj } });
                                                    }}
                                                    onResetOrderSelection={(e) => {
                                                        this.getStudentDetails(studentRecId);
                                                    }}
                                                    onSubmitOrderSelection={(e) => {
                                                        this.setState({ view: viewStatus.REVIEW });
                                                    }}
                                                />) :
                                        this.state.view === viewStatus.REVIEW ?
                                            <ReviewMenu dataSet={this.formatSelectedItems()} isMobile={isMobile} {...this}
                                                gradeList={gradeList}
                                                isParent={this.state.isParent}
                                                isPaymentPending={this.state.isPaymentPending}
                                                paymentProcessPendingBox={this.paymentProcessPendingBox}
                                                currency_symbol={currency_symbol(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                mealType={this.state.mealType}
                                                hiddenDays={getNotWorkingDays(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                price={this.calculatePrice()}
                                                initialPrices={this.state.initialPrices || {}}
                                                studentData={this.state.studentData}

                                                onSubmitOrderReviewSelection={() => {
                                                    //const price= localStorage.getItem('price')
                                                    if (this.state.isInstantPayment) {

                                                        // if(price > 0){
                                                        this.setState({ view: viewStatus.INSTPAY });
                                                        // }else{
                                                        //   this.prepareForSave(false);
                                                        //}                                            

                                                        //} else if(price > 0){
                                                        //    this.setState({view:viewStatus.INSTPAY});
                                                    } else {
                                                        //this.prepareForSave(false);
                                                        this.setState({ view: viewStatus.PAYSUMMARY });
                                                    }

                                                }} onBackReview={(e) => {
                                                    this.setState({ view: viewStatus.ORDER });
                                                }} /> :
                                            this.state.view === viewStatus.PAYSUMMARY ?
                                                <PaySummary {...this}
                                                    currency_symbol={currency_symbol(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                    mealType={this.state.mealType}
                                                    isParent={this.state.isParent}
                                                    studentData={this.state.studentData}
                                                    dataSet={this.formatSelectedItems()}
                                                    price={this.calculatePrice()} initialPrices={this.state.initialPrices || {}}
                                                    loading={this.state.loading}
                                                    showHideLoading={(showHide) => {
                                                        this.setState({ loading: showHide })
                                                    }}
                                                    onSubmitPayment={(resp, callback) => {
                                                        this.prepareForSave(false, resp.salesTaxAmt, callback);
                                                    }} onBackOrderReview={(e) => {
                                                        this.setState({ view: viewStatus.REVIEW });
                                                    }}
                                                /> :
                                                this.state.view === viewStatus.INSTPAY ?
                                                    <InstantPayment {...this} {...this.state}
                                                        schoolData={this.state.donateSchools}
                                                        donationObject={this.state.isParent ? getDonationData(this.state.studentData.mealSchoolId) : {}}
                                                        currency_symbol={currency_symbol(this.state.isParent ? this.state.studentData.mealSchoolId : 0)}
                                                        mealType={this.state.mealType}
                                                        isPrePayForOrderStatus={this.state.isPrePayForOrderStatus}
                                                        isAddBalOnline={this.state.isAddBalOnline}
                                                        isParent={this.state.isParent}
                                                        studentData={this.state.studentData}
                                                        dataSet={this.formatSelectedItems()}
                                                        price={this.calculatePrice()}
                                                        prepareSaveObject={(salesTaxAmt, resObj) => {
                                                            const { _formData, bal } = resObj
                                                            return { ...this.prepareSaveObject(salesTaxAmt), ..._formData }
                                                        }}
                                                        initialPrices={this.state.initialPrices || {}}
                                                        loading={this.state.loading}
                                                        showHideLoading={(showHide) => {
                                                            this.setState({ loading: showHide })
                                                        }}
                                                        onSubmitPayment={(resp, callback) => {
                                                            if (resp.doOrderMenuCall == 'NO') {
                                                                this.stripePaymentDone(callback)
                                                            } else {
                                                                this.onPaymentDone(resp, callback);
                                                            }
                                                        }} onBackOrderReview={(e) => {
                                                            this.setState({ view: viewStatus.REVIEW });
                                                        }} />
                                                    :

                                                    <div className="row">
                                                        <div className="col-md-12 text-center">
                                                            loading......
                                                        </div>
                                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
                {this.state.view === viewStatus.ORDER &&
                    <div className="row" style={fixedPossition}>
                        <div className="col-md-6 col-xs-12">
                            <div className="text-center" style={{ margin: '10px', alignItems: "center" }}>

                                <span style={dot}>&nbsp;</span><span>Available Meals &nbsp;&nbsp;</span>
                                <span style={dot2}>&nbsp;</span><span>Selected Meals &nbsp;&nbsp;</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <div className="text-center " style={{ margin: '10px' }}>
                                <p className="color-1"><i className="fa fa-info-circle" aria-hidden="true"></i> {
                                    getOrderCustomMessage((!this.state.isParent) ? 0 : this.state.studentData.mealSchoolId).length > 0 ?
                                        getOrderCustomMessage((!this.state.isParent) ? 0 : this.state.studentData.mealSchoolId) :
                                        'Please select your choice of Side and A La Carte Items along with Entree'}
                                    {this.state.scrollTop >= 50 && <span id='scrollUpBtn' style={{ position: 'fixed', right: '15px', marginTop: '10px' }}>
                                        &nbsp;&nbsp; &nbsp;&nbsp; <a title="Go to top" onClick={() => {
                                            const id = "scrollDiv";
                                            document.getElementById(id).scrollTop = 0;
                                        }} style={{
                                            fontSize: '44px', cursor: 'pointer', color: 'white', backgroundColor: 'rgb(234, 112, 102)',
                                            padding: '5px', borderRadius: '10px'
                                        }}><i className="fa fa-arrow-up" aria-hidden="true"></i></a>
                                    </span>}</p>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}
OrderMenu.contextTypes = {
    router: PropTypes.object.isRequired
}
export default OrderMenu


// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/orderMenu.jsx